import TeamMemberCard from './ui/TeamMemberCard'
import useTranslation from '../hooks/useTranslation'
import FloatingHeadline from '../UI/FloatingHeadline/FloatingHeadline'
import Headline from './ui/Headline'
import Container from '../UI/Container/Container'
import SlideInView from '../UI/SlideInView/SlideInView'
import FullHeightContainer from '../UI/FullHeightContainer/FullHeightContainer'
import christoph from '../../assets/image/team/christoph.jpg'
import fatih from '../../assets/image/team/fatih.jpg'
import jana from '../../assets/image/team/jana.jpg'
import nathalie from '../../assets/image/team/nathalie.jpg'
import nicole from '../../assets/image/team/nicole.jpg'
import patrick from '../../assets/image/team/patrick.jpg'
import sandra from '../../assets/image/team/sandra.jpg'

function TeamSection() {
  const t = useTranslation()
  const { kicker, headline, members } = t.landing.team
  const images = [nicole, nathalie, jana, sandra, christoph, fatih, patrick]
  return (
    <FullHeightContainer center id="team">
      <div>
        <Container>
          <SlideInView>
            <div>
              <FloatingHeadline text={kicker} />
              <Headline headline={headline} size="xlarge" className="mt-7 mb-10" />
              <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {members.map((member, index) => (
                  <TeamMemberCard key={member} member={{ name: member, image: images[index] }} />
                ))}
              </div>
            </div>
          </SlideInView>
        </Container>
      </div>
    </FullHeightContainer>
  )
}

export default TeamSection
